var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_24_185",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_24_185",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAACoElEQVRoge2YP2gTYRTAfy+NoXYpDnZp3Vzs2RY7OLh16OQkiFqVikUCKjiWKgilf0xw0VGHiiCd6qII6mBRcKggqaZcI7UgYmoRoSBdapvkObS2MZdc7i6XhMr9luTeve/9uXff+77vICAgIKCeSKGg59Gv44LcB1pBSwwrJi+hKz7Y2JSnQaPT51ue598JWfwh94DWEpbqSZtuPth/sCSw27AmIBoF0rUPxR6FbyHVaKHcMgfyOTI0P6HCwJaBHVOy/a+II6tULV6sWtvXUqijE6mxrkulYrR9hZob914VSNjpVJm5pvDGNTsF2woAdA+ZB3Mi7xWaNyU1q8BqJsvRhVjnJ7v4yk7iRNxYFLS/RLzVQgUdKBc8OOxCszHjKcrdyuNyiMgdc6zrsRNVx210X+OPQYS33qNyzIw0yHWnymXnQD6dgx/bpCGcQNgPVZkDK0pDd2q8/avTmFwtZMnbXWlVzgBZN+MckhOVs26CBw8rcTJuTAuMuR1XFmXEvHX4pdthnrYSHyLtIwgvvIwtjrya/5zy9FC87YWGJZfZwznAVbmLoqQjufU+pk55ei09b+bMYWMF5TSw7tUGsIGE+mZj3T+9GqhoN5qMGe8UHfJuQQbNcaOi1uyqjZai84Y5BZwEN21UnpjjxgmbE48jfDkPZCNcBMou+3ksNmbWLlQaPPhUAYCOm6kOyeZmFG0qvFdQgbVcSI7Njxqzfvj17UQ2N3poTgXLgaMQEbniV/DgYwX+cqDvmSoCIigCbP1uXS9P9vrq8z88E+8yggTqTZBAvQkSqDdBAvUmSMAVwm+/TdY2AdWHfpusUQK6oEr/8mTvZb8th/02mI/AF5D40vfIA173ZKrhowoJyBuFFiC+tLE66fVzSUBAgDP+AA9E1iFhhBpkAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.efa4cb9b43057862a537fddf086b8e59.svg";
export { ForwardRef as ReactComponent };